import { render, staticRenderFns } from "./Branch-office-body.vue?vue&type=template&id=5d3d750d"
import script from "./Branch-office-body.vue?vue&type=script&lang=js"
export * from "./Branch-office-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports